import { useMutation } from '@tanstack/react-query'
import { queryClient } from 'src/'
import { apiBase } from '~utils/base-url'
import { useFetch } from '~utils/fetch-request'

export interface BookmarkPayload {
  documentId: number
}

export function useAddBookmark() {
  const fetchRequest = useFetch()

  return useMutation({
    mutationFn: (payload: BookmarkPayload) =>
      fetchRequest(
        `${apiBase()}/documents/bookmarks`,
        undefined,
        payload,
        'POST',
      ),
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({
        queryKey: ['/documents/bookmarks'],
      })
    },
  })
}
